import { z } from "zod";
import { canvasElementBaseSchema } from "./canvas-element";

const nounIconSchemaInternal = z.object({
  type: z.literal("noun-icon"),
  id: z.string(),
  provider: z.string(),
  rotate: z.number().optional().default(0),
});

export const nounIconSchema = canvasElementBaseSchema.merge(nounIconSchemaInternal);
export type NounIconElement = z.infer<typeof nounIconSchema>;
